/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const GoArrow = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
    >
      <path
        d="M1.50255 8.00079L9.09255 8.00079L5.79254 11.2908C5.60424 11.4791 5.49845 11.7345 5.49845 12.0008C5.49845 12.2671 5.60424 12.5225 5.79254 12.7108C5.98085 12.8991 6.23624 13.0049 6.50254 13.0049C6.76885 13.0049 7.02424 12.8991 7.21254 12.7108L12.2125 7.71079C12.3036 7.61569 12.375 7.50354 12.4225 7.38079C12.5226 7.13733 12.5226 6.86425 12.4225 6.62079C12.375 6.49804 12.3036 6.38589 12.2125 6.29079L7.21255 1.29079C7.11958 1.19706 7.00898 1.12267 6.88712 1.0719C6.76526 1.02113 6.63456 0.994993 6.50255 0.994993C6.37053 0.994993 6.23983 1.02113 6.11797 1.0719C5.99611 1.12267 5.88551 1.19706 5.79255 1.29079C5.69882 1.38376 5.62442 1.49435 5.57365 1.61621C5.52289 1.73807 5.49675 1.86878 5.49675 2.00079C5.49675 2.1328 5.52289 2.26351 5.57365 2.38537C5.62442 2.50723 5.69882 2.61783 5.79255 2.71079L9.09255 6.00079L1.50255 6.00079C1.23733 6.00079 0.982975 6.10615 0.795438 6.29368C0.607902 6.48122 0.502546 6.73557 0.502546 7.00079C0.502546 7.26601 0.607902 7.52036 0.795438 7.7079C0.982974 7.89543 1.23733 8.00079 1.50255 8.00079Z"
        fill="#EAEEF4"
      />
    </svg>
  )
}
